module.exports = __webpack_public_path__ + "static/img/gd-04.b9f14a5a.jpg";